import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import CategoryComponent from "../components/CategoryComponent";
import Partners from "./Partners";
import Category from "./Category";
import '../assets/css/Home.css';

class SearchResult extends Component {
    constructor(props) {
        super(props);
        this.state = {
            results: this.props.location.state ? this.props.location.state.results : {
                categories: [],
                partners: [],
                products: []
            }
        };
    }

    render() {
        let {results} = this.state;
        return (
            <div className="container category-list partner-list">
                <h1 className="heading">Search Results - {this.props.location.state.search}</h1>
                <hr/>
                {results.categories.length > 0 || results.partners.length > 0 || results.products.length > 0 ?
                    [
                        results.categories.length > 0 ?
                            [
                                <h4 className="heading" key="heading">Categories</h4>,
                                <CategoryComponent categories={results.categories} key="categories"/>
                            ]
                            : null,
                        results.partners.length > 0 ?
                            [
                                <h4 className="heading" key="heading">Partners</h4>,
                                <Partners partners={results.partners} key="partners"/>
                            ]
                            : null,
                        results.products.length > 0 ?
                            [
                                <h4 className="heading" key="heading">Products</h4>,
                                <Category products={results.products} key="products"/>
                            ]
                            : null
                    ] : <p>No Products Found!</p>
                }
            </div>
        );
    }

}

export default withRouter(SearchResult);